const componentsCommon = require("cb-components-common").default;
const request = componentsCommon.request;

export function getAwardInfo(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/award/select",
        method: "get",
        params: _params
    });
}

export function getAwardChart(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/award/select/chart",
        method: "get",
        params: _params
    });
}

export function getAwardCompany(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/award/select/company",
        method: "get",
        params: _params
    });
}

export function getAwardManager(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/award/select/manager",
        method: "get",
        params: _params
    });
}

export function searchManager(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/award/select/searchManager",
        method: "get",
        params: _params
    });
}